// legacyMigration.js — einmalige Umbenennung der localStorage-Keys
// nach dem Rebranding MediFlow → dida.
//
// Kopiert alle "mediflow_*"-Keys nach "dida_*" (nur wenn das Ziel noch
// nicht existiert) und entfernt danach die alten Keys. Bestehende
// Demo-Daten von Nutzern bleiben so vollständig erhalten.
export function migrateLegacyStorage() {
  try {
    const legacy = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith("mediflow_")) legacy.push(key);
    }
    legacy.forEach((oldKey) => {
      const newKey = "dida_" + oldKey.slice("mediflow_".length);
      if (localStorage.getItem(newKey) === null) {
        const val = localStorage.getItem(oldKey);
        if (val !== null) localStorage.setItem(newKey, val);
      }
      localStorage.removeItem(oldKey);
    });
  } catch (e) {
    console.warn("Storage-Migration:", e);
  }
}
